import { Alert, Spinner } from '@a-ui/react';
import React from 'react';
import Appointment from '../../components/Appointment';
import Ticket from '../../components/Ticket';
import Typography from '../../components/Typography';
import Widget from '../../components/Widget';
import { api } from '../../hooks/api.hooks';
import { IClassNames } from '../../hooks/classNames.hooks';
import { translate } from '../../i18n';

interface ECounterWidgetProps extends IClassNames {}

const ECounterWidget: React.FC<ECounterWidgetProps> = ({ ...props }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [items, setItems] = React.useState<(Api.Appointment | Api.Ticket)[]>([]);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await api.get<(Api.Appointment | Api.Ticket)[]>('/activities');
        setItems(data);
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
        setError(true);
      }
    };

    fetch();
  }, []);

  if (!isLoading && error) {
    return <></>;
  }

  return (
    <Widget
      title="ecounter.title"
      description="dashboard.widget.ecounter.description"
      ctaText="dashboard.widget.ecounter.cta"
      ctaTo="/mijn-eloket"
      unstyled
      {...props}
    >
      {!items.length && isLoading && <Spinner />}

      {!items.length && !isLoading && (
        <Alert className="u-margin-bottom" inline>
          <Typography>{translate('dashboard.widget.ecounter.empty')}</Typography>
        </Alert>
      )}

      {items.map((item) => (
        <React.Fragment key={item.id}>
          {(item as Api.Appointment).startTime ? (
            <Appointment data={item as Api.Appointment} />
          ) : (
            <Ticket data={item as Api.Ticket} />
          )}
        </React.Fragment>
      ))}
    </Widget>
  );
};

export default ECounterWidget;
